export const baseURL = process.env.NODE_ENV === 'development' 
? "http://localhost:3045"
: window.location.href.split(".")[3] === "staging"
?"https://atci.ABCtalentacademy.staging.accenture.com/abc-talentstage-apis"
:"https://atci.ABCtalentacademy.accenture.com/abc-talent-apis";

export const lttbaseUrl = 'https://atci.lkm.accenture.com/lttmicrosite-apis';
export const baseUrl = "https://atci.ABCtalentacademy.accenture.com/abc-talent-apis";